import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { BackgroundDecorationComponent } from '../shared-components/background-decoration/background-decoration.component';

@Component({
  selector: 'app-page-not-found',
  imports: [BackgroundDecorationComponent, MatIconModule, MatButtonModule],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss',
  standalone: true,
})
export class PageNotFoundComponent {
  private location = inject(Location);
  private router = inject(Router);


  notFoundNavigation(path: string) {
    switch (path) {
      case 'back':
        this.location.back();
        break;
      case 'home':
        this.router.navigate(['']);
        break;
      default:
        break;
    }
  }
}
